module.exports = __webpack_public_path__ + "static/img/80.974c291.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/80.jpg
// module id = mApZ
// module chunks = 1